export default class Criteria {
  state: string;

  city: string;

  priority?: string;

  endDate: Date;

  startDate: Date;

  constructor(_state: string, _city: string, _endDate: Date, _startDate: Date) {
    this.state = _state;
    this.city = _city;
    this.startDate = _startDate;
    this.endDate = _endDate;
  }
}
